// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4873667d","977":"75437f7a"}[chunkId] + ".chunk.js";
};